/* eslint-disable */
import { AxiosRequestConfig } from 'axios'
import queryString from 'query-string'
import { Visao } from 'src/componentes'
import {
  AlunoCertificacaoPayload,
  CursoCertificacaoPayload,
  DisciplinaPayload,
  FiltrosTicketParceiroCertificacao,
  PesquisaTicketParceiroCertificacaoDados,
  PesquisaAlunoCertificacaoDTO,
  PesquisaAlunosCertificacaoResposta,
  PesquisaCursoCertificacaoDTO,
  PesquisaCursosCertificacaoResposta,
  PesquisaUsuarioDTO,
  ProfessorCertificacaoPayload,
  TicketParceiroCertificacaoHistorico,
  TurmaCertificacaoPayload
} from 'src/dto'
import {
  Documento,
  DocumentosParaAprovacao,
  ModalidadeCurso,
  OpcoesPaginacao,
  RespostaPadraoAPI,
  RespostaPadraoDadosAPI,
  RespostaPaginacao,
  ResultadoDaAprovacaoDeDocumentos,
  ResumoDocumentosAlunoCertificacao,
  ResumoDocumentosCursoCertificacao,
  ResumoDocumentosParceiroCertificacao,
  ResumoDocumentosProfessorCertificacao,
  ResumoDocumentosTurmaCertificacao,
  SituacaoTurmaCertificacao,
  TipoOrdenacao,
  TipoTurmaCertificacao,
  UsuarioPerfil,
  UsuarioSituacao
} from 'src/tipos'
import { SituacaoAlunoCertificacao } from 'src/tipos/aluno-certificacao'
import { ParceiroCertificacao } from 'src/tipos/parceiroCertificacao-usuario'

import { gatewayApi } from '../instancias-api'

const urlBase = '/parceiroCertificacao'
const headers = { headers: { 'Content-Type': 'multipart/form-data' } }

export const RequisitarListaParceiros = async (
  nome: string,
  email: string,
  situacao: keyof typeof UsuarioSituacao,
  cnpj: string,
  docIdentidade: string,
  perfis: Array<keyof typeof UsuarioPerfil>,
  pagina: number,
  quantidadeRegistros: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<{
  registros: PesquisaUsuarioDTO[]
  opcoesPaginacao: OpcoesPaginacao
}> => {
  try {
    let campoOrdenacao = chaveOrdenacao

    if (chaveOrdenacao === 'nomeApresentacao') campoOrdenacao = 'nome'

    const ordem = chaveOrdenacao
      ? `${campoOrdenacao}${
          tipoOrdenacao === TipoOrdenacao.Crescente ? '' : '_Desc'
        }`
      : undefined

    const filtros = queryString.stringify({
      nome,
      email,
      cnpj,
      docIdentidade,
      perfis,
      situacao: situacao === 'Todas' ? null : situacao,
      quantidadeRegistros,
      pagina,
      ordem
    })

    const {
      data: { itens, quantidade }
    } = await gatewayApi.get<any>(`${urlBase}/parceiros?${filtros}`)

    const opcoesPaginacao = {
      pagina,
      tamanhoPagina: quantidadeRegistros,
      totalRegistros: quantidade,
      totalPaginas: Math.ceil(quantidade / quantidadeRegistros)
    }
    return { registros: itens, opcoesPaginacao }
  } catch {
    return null
  }
}

export const ObterParceiroCertificacaoPorIdUsuario = async (
  id: string
): Promise<any> => {
  const {
    data: { data }
  } = await gatewayApi.get<RespostaPadraoDadosAPI<any>>(
    `${urlBase}/meu-cadastro/${id}`
  )

  return data
}

export const EditarParceiroCertificacaoPorIdUsuario = async (
  id: string,
  payload: ParceiroCertificacao
): Promise<any> => {
  const payloadAlterado = {
    Nome: payload.nome,
    NomeSocial: payload.nomeSocial,
    Cnpj: payload.cnpj,
    PaisResidencia: payload.endereco.paisResidencia,
    Cep: payload.endereco.cep,
    Logradouro: payload.endereco.logradouro,
    Numero: payload.endereco.numero,
    Complemento: payload.endereco.complemento,
    Bairro: payload.endereco.bairro,
    Cidade: payload.endereco.cidade,
    UF: payload.endereco.uf,
    Foto: payload.foto
  }

  const { data } = await gatewayApi.put<RespostaPadraoDadosAPI<any>>(
    `${urlBase}/meu-cadastro/${id}`,
    payloadAlterado
  )

  return data.data
}

export const EnviarDocumentosParceiroCertificacao = async (
  usuarioId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/documentos/meu-cadastro/${usuarioId}`
  const resposta = await gatewayApi.post(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const EditarDocumentosParceiroCertificacao = async (
  usuarioId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/meu-cadastro/documento/${usuarioId}/editar`
  const resposta = await gatewayApi.put(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const ObterResumoDeDocumentosParceiroCertificacao = async (
  usuarioId: string
): Promise<ResumoDocumentosParceiroCertificacao[]> => {
  const { data } = await gatewayApi.get<
    RespostaPaginacao<ResumoDocumentosParceiroCertificacao>
  >(`${urlBase}/meu-cadastro/resumo-documentos/${usuarioId}`)

  if (!data) {
    return [] as ResumoDocumentosParceiroCertificacao[]
  }

  return data.itens
}

export const RequisitarDocumentoParceiroCertificacao = async (
  usuarioId: string,
  documentoId: string
): Promise<Documento> => {
  const resposta = await gatewayApi.get(
    `${urlBase}/meu-cadastro/resumo-documentos/${usuarioId}/documento/${documentoId}/visualizar`
  )

  if (resposta?.status !== 200) return null

  return resposta.data
}

export const RemoverDocumentoParceiroCertificacao = async (
  usuarioId: string,
  documentoId: string
): Promise<boolean> => {
  await gatewayApi.delete(
    `${urlBase}/meu-cadastro/resumo-documentos/${usuarioId}/documento/${documentoId}/excluir`
  )

  return true
}

export const DownloadDocumentosParceiroCertificacao = async (
  usuarioId: string,
  documentoId: string
): Promise<void> => {
  const rota = `${urlBase}/meu-cadastro/resumo-documentos/${usuarioId}/documento/${documentoId}`
  const config = { responseType: 'blob' } as AxiosRequestConfig
  const resposta = await gatewayApi.get(rota, config)

  if (resposta?.status !== 200) return null

  if (resposta.data) {
    saveAs(resposta.data)
  }
}

// ///////////////////////////////////////[CURSOS]///////////////////////////////////////////////////

export const ObterTotalCursos = async (
  usuarioId: string
): Promise<{ total: number }> => {
  const resultado = await gatewayApi.get<{ total: number }>(
    `${urlBase}/total-cursos?userId=${usuarioId}`
  )
  return resultado.data
}

export const RequisitarListaCursosCertificacao = async (
  userId: string,
  role: Visao,
  paginated: number,
  nome?: string,
  usuarioPerfilFiltro?: string,
  modalidade?: keyof typeof ModalidadeCurso | 'Todas',
  dataCriacaoCurso?: string,
  pagina?: number,
  quantidadeRegistros?: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<{
  registros: PesquisaCursoCertificacaoDTO[]
  opcoesPaginacao: OpcoesPaginacao
}> => {
  try {
    const ordem = chaveOrdenacao
      ? `${chaveOrdenacao}${
          tipoOrdenacao === TipoOrdenacao.Crescente ? '' : '_Desc'
        }`
      : undefined

    const filtros = queryString.stringify({
      nome,
      modalidade: modalidade === 'Todas' ? null : modalidade,
      userId,
      usuarioPerfilFiltro,
      dataCriacaoCurso,
      quantidadeRegistros,
      pagina,
      ordem,
      role,
      paginated
    })

    const {
      data: { itens, quantidade }
    } = await gatewayApi.get<PesquisaCursosCertificacaoResposta>(
      `${urlBase}/cursos?${filtros}`
    )

    const opcoesPaginacao = {
      pagina,
      tamanhoPagina: quantidadeRegistros,
      totalRegistros: quantidade,
      totalPaginas: Math.ceil(quantidade / quantidadeRegistros)
    }

    return new Promise(resolve =>
      resolve({ registros: itens, opcoesPaginacao })
    )
  } catch {
    return null
  }
}

export const RequisitarTodosCursosCertificacao = async (
  userId: string,
  role: Visao
): Promise<any> => {
  const filtros = queryString.stringify({
    userId,
    role
  })

  const { data } = await gatewayApi.get<CursoCertificacaoPayload>(
    `${urlBase}/cursos/todos?${filtros}`
  )

  return data
}

export const RequisitarCursoCertificacao = async (
  id: string
): Promise<CursoCertificacaoPayload> => {
  const { data } = await gatewayApi.get<CursoCertificacaoPayload>(
    `${urlBase}/${id}/curso`
  )

  return data
}

export const InserirCursoCertificacao = async (
  payload: CursoCertificacaoPayload,
  usuarioId: string
): Promise<any> => {
  const response = await gatewayApi.post<{ cursoId: string }>(
    `${urlBase}/cursos/criar`,
    {
      nome: payload.nome,
      modalidade: payload.modalidade,
      cargaHoraria: payload.cargaHoraria,
      duracao: payload.duracao,
      divisao: payload.divisao,
      modulosCertificacao: payload.modulosCertificacao,
      disciplinasCertificacao: payload.disciplinasCertificacao,
      area: payload.area,
      nomeCoordenador: payload.nomeCoordenador,
      cpfCoordenador: payload.cpfCoordenador,
      titulacaoCoordenador: payload.titulacaoCoordenador,
      linkEmec: payload.linkEmec,
      dataCriacaoCurso: new Date(),
      usuarioPerfilId: usuarioId
    }
  )

  return response.data
}

export const EditarCursoCertificacao = async (
  id: string,
  payload: CursoCertificacaoPayload,
  usuarioId: string
): Promise<boolean> => {
  await gatewayApi.put<RespostaPadraoAPI>(`${urlBase}/${id}/editar`, {
    nome: payload.nome,
    modalidade: payload.modalidade,
    cargaHoraria: payload.cargaHoraria,
    duracao: payload.duracao,
    divisao: payload.divisao,
    modulosCertificacao: payload.modulosCertificacao,
    disciplinasCertificacao: payload.disciplinasCertificacao,
    dataCriacaoCurso: payload.dataCriacaoCurso,
    area: payload.area,
    nomeCoordenador: payload.nomeCoordenador,
    cpfCoordenador: payload.cpfCoordenador,
    titulacaoCoordenador: payload.titulacaoCoordenador,
    linkEmec: payload.linkEmec,
    usuarioPerfilId: usuarioId
  })

  return true
}

export const ObterResumoDeDocumentosCursoCertificacao = async (
  cursoId: string
): Promise<ResumoDocumentosCursoCertificacao[]> => {
  const { data } = await gatewayApi.get<
    RespostaPaginacao<ResumoDocumentosCursoCertificacao>
  >(`${urlBase}/cursos/resumo-documentos/${cursoId}`)

  if (!data) {
    return [] as ResumoDocumentosCursoCertificacao[]
  }

  return data.itens
}

export const RequisitarDocumentoCursoCertificacao = async (
  cursoId: string,
  documentoId: string
): Promise<Documento> => {
  const resposta = await gatewayApi.get(
    `${urlBase}/cursos/resumo-documentos/${cursoId}/documento/${documentoId}/visualizar`
  )

  if (resposta?.status !== 200) return null

  return resposta.data
}

export const RemoverDocumentoCursoCertificacao = async (
  cursoId: string,
  documentoId: string
): Promise<boolean> => {
  await gatewayApi.delete(
    `${urlBase}/cursos/resumo-documentos/${cursoId}/documento/${documentoId}/excluir`
  )

  return true
}

export const EnviarDocumentosCursoCertificacao = async (
  cursoId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/${cursoId}`
  const resposta = await gatewayApi.post(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const DownloadDocumentosCursoCertificacao = async (
  cursoId: string,
  documentoId: string
): Promise<void> => {
  const rota = `${urlBase}/cursos/resumo-documentos/${cursoId}/documento/${documentoId}`
  const config = { responseType: 'blob' } as AxiosRequestConfig
  const resposta = await gatewayApi.get(rota, config)

  if (resposta?.status !== 200) return null

  if (resposta.data) {
    saveAs(resposta.data)
  }
}

export const EditarDocumentosCursoCertificacao = async (
  cursoId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/cursos/${cursoId}`
  const resposta = await gatewayApi.put(rota, form, headers)

  return Boolean(resposta.status < 300)
}

// ///////////////////////////////////////[TURMAS]///////////////////////////////////////////////////

export const RequisitarListaTurmasCertificacao = async (
  userId: string,
  role: Visao,
  paginated: number,
  nome?: string,
  status?: keyof typeof SituacaoTurmaCertificacao | 'Todas',
  tipo?: keyof typeof TipoTurmaCertificacao | 'Todas',
  dataCriacaoTurma?: string,
  usuarioPerfilFiltro?: string,
  pagina?: number,
  quantidadeRegistros?: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<{
  registros: PesquisaCursoCertificacaoDTO[]
  opcoesPaginacao: OpcoesPaginacao
}> => {
  try {
    const ordem = chaveOrdenacao
      ? `${chaveOrdenacao}${
          tipoOrdenacao === TipoOrdenacao.Crescente ? '' : '_Desc'
        }`
      : undefined

    const filtros = queryString.stringify({
      nome,
      status: status === 'Todas' ? null : status,
      tipo: tipo === 'Todas' ? null : tipo,
      dataCriacaoTurma,
      userId,
      usuarioPerfilFiltro,
      quantidadeRegistros,
      pagina,
      ordem,
      role,
      paginated
    })

    const {
      data: { itens, quantidade }
    } = await gatewayApi.get<PesquisaCursosCertificacaoResposta>(
      `${urlBase}/turmas?${filtros}`
    )

    const opcoesPaginacao = {
      pagina,
      tamanhoPagina: quantidadeRegistros,
      totalRegistros: quantidade,
      totalPaginas: Math.ceil(quantidade / quantidadeRegistros)
    }

    return new Promise(resolve =>
      resolve({ registros: itens, opcoesPaginacao })
    )
  } catch {
    return null
  }
}

export const ObterTotalTurma = async (
  usuarioId: string
): Promise<{
  total: number
}> => {
  const resultado = await gatewayApi.get<{ total: number }>(
    `${urlBase}/total-turmas`,
    { params: { userId: usuarioId } }
  )
  return resultado.data
}

export const InserirTurmaCertificacao = async (
  payload: TurmaCertificacaoPayload,
  usuarioId: string
): Promise<any> => {
  const response = await gatewayApi.post<{ turmaId: string }>(
    `${urlBase}/turmas/criar`,
    {
      nome: payload.nome,
      cursoCertificacaoId: payload.cursoCertificacaoId,
      divisao: payload.divisao,
      modulosCertificacao: payload.modulosCertificacao,
      disciplinasCertificacao: payload.disciplinasCertificacao,
      dataInicio: payload.dataInicio,
      dataFim: payload.dataFim,
      status: payload.status,
      tipo: payload.tipo,
      cargaHoraria: payload.cargaHoraria,
      ppc: 'Nao',
      // diario: payload.diario,
      tipoCertificado: payload.tipoCertificado,
      valorCertificacao: payload.valorCertificacao,
      professores: payload.professores,
      // docsProf: payload.docsProf,
      // docsAlunos: payload.docsAlunos,
      usuarioPerfilId: usuarioId
    }
  )

  return response.data
}

export const EditarTurmaCertificacao = async (
  id: string,
  payload: TurmaCertificacaoPayload,
  usuarioId: string
): Promise<boolean> => {
  await gatewayApi.put<RespostaPadraoAPI>(`${urlBase}/${id}/turmas/editar`, {
    nome: payload.nome,
    cursoCertificacaoId: payload.cursoCertificacaoId,
    divisao: payload.divisao,
    modulosCertificacao: payload.modulosCertificacao,
    disciplinasCertificacao: payload.disciplinasCertificacao,
    dataInicio: payload.dataInicio,
    dataFim: payload.dataFim,
    status: payload.status,
    tipo: payload.tipo,
    cargaHoraria: payload.cargaHoraria,
    ppc: payload.ppc,
    // diario: payload.diario,
    tipoCertificado: payload.tipoCertificado,
    valorCertificacao: payload.valorCertificacao,
    professores: payload.professores,
    // docsProf: payload.docsProf,
    // docsAlunos: payload.docsAlunos,
    usuarioPerfilId: usuarioId
  })

  return true
}

export const RequisitarTodasTurmasCertificacao = async (
  userId: string,
  role: Visao
): Promise<any> => {
  const filtros = queryString.stringify({
    userId,
    role
  })

  const { data } = await gatewayApi.get<TurmaCertificacaoPayload>(
    `${urlBase}/turmas/todas?${filtros}`
  )

  return data
}

export const RequisitarTurmaCertificacao = async (
  id: string
): Promise<TurmaCertificacaoPayload> => {
  const { data } = await gatewayApi.get<TurmaCertificacaoPayload>(
    `${urlBase}/${id}/turma`,
    {
      headers: {
        Accept: 'application/json'
      }
    }
  )

  return data
}

export const ObterResumoDeDocumentosTurmaCertificacao = async (
  turmaId: string
): Promise<ResumoDocumentosTurmaCertificacao[]> => {
  const { data } = await gatewayApi.get<
    RespostaPaginacao<ResumoDocumentosTurmaCertificacao>
  >(`${urlBase}/turmas/resumo-documentos/${turmaId}`)

  if (!data) {
    return [] as ResumoDocumentosTurmaCertificacao[]
  }

  return data.itens
}

export const RequisitarDocumentoTurmaCertificacao = async (
  turmaId: string,
  documentoId: string
): Promise<Documento> => {
  const resposta = await gatewayApi.get(
    `${urlBase}/turmas/resumo-documentos/${turmaId}/documento/${documentoId}/visualizar`
  )

  if (resposta?.status !== 200) return null

  return resposta.data
}

export const EnviarDocumentosTurmaCertificacao = async (
  turmaId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/turmas/${turmaId}`
  const resposta = await gatewayApi.post(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const DownloadDocumentosTurmaCertificacao = async (
  turmaId: string,
  documentoId: string
): Promise<void> => {
  const rota = `${urlBase}/turmas/resumo-documentos/${turmaId}/documento/${documentoId}`
  const config = { responseType: 'blob' } as AxiosRequestConfig
  const resposta = await gatewayApi.get(rota, config)

  if (resposta?.status !== 200) return null

  if (resposta.data) {
    saveAs(resposta.data)
  }
}

export const EditarDocumentosTurmaCertificacao = async (
  turmaId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/turmas/${turmaId}`
  const resposta = await gatewayApi.put(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const RemoverDocumentoTurmaCertificacao = async (
  turmaId: string,
  documentoId: string
): Promise<boolean> => {
  await gatewayApi.delete(
    `${urlBase}/turmas/resumo-documentos/${turmaId}/documento/${documentoId}/excluir`
  )

  return true
}

// ///////////////////////////////////////[ALUNOS]///////////////////////////////////////////////////

export const ObterTotalAlunos = async (
  usuarioId: string
): Promise<{ total: number }> => {
  const resultado = await gatewayApi.get<{ total: number }>(
    `${urlBase}/total-alunos`,
    { params: { userId: usuarioId } }
  )
  return resultado.data
}

export const RequisitarListaAlunosCertificacao = async (
  userId: string,
  role: Visao,
  paginated: number,
  cpf?: string,
  nome?: string,
  email?: string,
  situacao?: keyof typeof SituacaoAlunoCertificacao | 'Todas',
  turmaId?: string,
  usuarioPerfilFiltro?: string,
  dataCriacaoAluno?: string,
  pagina?: number,
  quantidadeRegistros?: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<{
  registros: PesquisaAlunoCertificacaoDTO[]
  opcoesPaginacao: OpcoesPaginacao
}> => {
  try {
    const ordem = chaveOrdenacao
      ? `${chaveOrdenacao}${
          tipoOrdenacao === TipoOrdenacao.Crescente ? '' : '_Desc'
        }`
      : undefined

    const filtros = queryString.stringify({
      cpf,
      nome,
      email,
      situacao: situacao === 'Todas' ? null : situacao,
      turmaId: turmaId === '' ? null : turmaId,
      userId,
      usuarioPerfilFiltro,
      dataCriacaoAluno,
      quantidadeRegistros,
      pagina,
      ordem,
      role,
      paginated
    })

    const {
      data: { itens, quantidade }
    } = await gatewayApi.get<PesquisaAlunosCertificacaoResposta>(
      `${urlBase}/alunos?${filtros}`
    )

    const opcoesPaginacao = {
      pagina,
      tamanhoPagina: quantidadeRegistros,
      totalRegistros: quantidade,
      totalPaginas: Math.ceil(quantidade / quantidadeRegistros)
    }

    return new Promise(resolve =>
      resolve({ registros: itens, opcoesPaginacao })
    )
  } catch {
    return null
  }
}

export const InserirAlunoCertificacao = async (
  payload: AlunoCertificacaoPayload,
  usuarioId: string
): Promise<any> => {
  const response = await gatewayApi.post<{ cursoId: string }>(
    `${urlBase}/alunos/criar`,
    {
      cpf: payload.cpf,
      nacionalidade: payload.nacionalidade,
      nome: payload.nome,
      email: payload.email,
      dataNascimento: payload.dataNascimento,
      celular: payload.celular,
      uf: payload.uf,
      cidade: payload.cidade,
      formacao: payload.formacao,
      profissao: payload.profissao,
      turmaCertificacaoId: payload.turmaCertificacaoId,
      situacao: payload.situacao,
      statusCertificado: payload.statusCertificado,
      nota1: payload.nota1,
      nota2: payload.nota2,
      tcc: payload.tcc,
      notaOrientador: payload.notaOrientador,
      notaBanca: payload.notaBanca,
      dataSolicitacaoDiploma: payload.dataSolicitacaoDiploma,
      dataEntregaDiploma: payload.dataEntregaDiploma,
      dataColacaoGrau: payload.dataColacaoGrau,
      usuarioPerfilId: usuarioId
    }
  )
  return response.data
}

const mapearDisciplinaNotaParaEdicao = (
  disciplina: DisciplinaPayload,
  divisao?: string
) => ({
  divisao,
  disciplinaId: disciplina.disciplinaId || disciplina.id,
  disciplinaNome: disciplina.disciplinaNome || disciplina.nome,
  nota1: disciplina.nota1 ?? '',
  nota2: disciplina.nota2 ?? ''
})

export const EditarAlunoCertificacao = async (
  id: string,
  payload: AlunoCertificacaoPayload,
  usuarioId: string
): Promise<boolean> => {
  await gatewayApi.put<RespostaPadraoAPI>(`${urlBase}/${id}/alunos/editar`, {
    cpf: payload.cpf,
    nacionalidade: payload.nacionalidade,
    nome: payload.nome,
    email: payload.email,
    dataNascimento: payload.dataNascimento,
    celular: payload.celular,
    uf: payload.uf,
    cidade: payload.cidade,
    formacao: payload.formacao,
    profissao: payload.profissao,
    turmaCertificacaoId: payload.turmaCertificacaoId,
    divisao: payload.divisao,
    situacao: payload.situacao,
    statusCertificado: payload.statusCertificado,
    nota1: payload.nota1,
    nota2: payload.nota2,
    tcc: payload.tcc,
    notaOrientador: payload.notaOrientador,
    notaBanca: payload.notaBanca,
    dataSolicitacaoDiploma: payload.dataSolicitacaoDiploma,
    dataEntregaDiploma: payload.dataEntregaDiploma,
    dataColacaoGrau: payload.dataColacaoGrau,
    ModuloDisciplinas: payload.disciplinasModulo?.map(modulo => ({
      disciplinas: modulo.disciplinas
        ?.map(d => mapearDisciplinaNotaParaEdicao(d, payload.divisao))
        .filter(d => d.disciplinaId)
    })),
    disciplinas: payload.disciplinas
      ?.map(d => mapearDisciplinaNotaParaEdicao(d, payload.divisao))
      .filter(d => d.disciplinaId),
    usuarioPerfilId: usuarioId
  })

  return true
}

export const RequisitarAlunoCertificacao = async (
  id: string
): Promise<AlunoCertificacaoPayload> => {
  const { data } = await gatewayApi.get<AlunoCertificacaoPayload>(
    `${urlBase}/${id}/alunos`
  )

  return data
}

export const ObterResumoDeDocumentosAlunoCertificacao = async (
  alunoId: string
): Promise<ResumoDocumentosAlunoCertificacao[]> => {
  const { data } = await gatewayApi.get<
    RespostaPaginacao<ResumoDocumentosAlunoCertificacao>
  >(`${urlBase}/alunos/resumo-documentos/${alunoId}`)

  if (!data) {
    return [] as ResumoDocumentosAlunoCertificacao[]
  }

  return data.itens
}

export const EnviarDocumentosAlunoCertificacao = async (
  alunoId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/documentos/aluno/${alunoId}`
  const resposta = await gatewayApi.post(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const RequisitarDocumentoAlunoCertificacao = async (
  alunoId: string,
  documentoId: string
): Promise<Documento> => {
  const resposta = await gatewayApi.get(
    `${urlBase}/alunos/resumo-documentos/${alunoId}/documento/${documentoId}/visualizar`
  )

  if (resposta?.status !== 200) return null

  return resposta.data
}

export const DownloadDocumentosAlunoCertificacao = async (
  alunoId: string,
  documentoId: string
): Promise<void> => {
  const rota = `${urlBase}/alunos/resumo-documentos/${alunoId}/documento/${documentoId}`
  const config = { responseType: 'blob' } as AxiosRequestConfig
  const resposta = await gatewayApi.get(rota, config)

  if (resposta?.status !== 200) return null

  if (resposta.data) {
    saveAs(resposta.data)
  }
}

export const EditarDocumentosAlunoCertificacao = async (
  alunoId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/alunos/documento/${alunoId}/editar`
  const resposta = await gatewayApi.put(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const RemoverDocumentoAlunoCertificacao = async (
  alunoId: string,
  documentoId: string
): Promise<boolean> => {
  await gatewayApi.delete(
    `${urlBase}/alunos/resumo-documentos/${alunoId}/documento/${documentoId}/excluir`
  )

  return true
}

// ///////////////////////////////////////[PROFESSORES]///////////////////////////////////////////////////

export const ObterTotalProfessores = async (
  usuarioId: string
): Promise<{ total: number }> => {
  const resultado = await gatewayApi.get<{ total: number }>(
    `${urlBase}/total-professores?userId=${usuarioId}`
  )
  return resultado.data
}

export const RequisitarListaProfessoresCertificacao = async (
  userId: string,
  role: Visao,
  paginated: number,
  cpf?: string,
  nome?: string,
  email?: string,
  usuarioPerfilFiltro?: string,
  dataCriacaoProfessor?: string,
  pagina?: number,
  quantidadeRegistros?: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<{
  registros: PesquisaCursoCertificacaoDTO[]
  opcoesPaginacao: OpcoesPaginacao
}> => {
  try {
    const ordem = chaveOrdenacao
      ? `${chaveOrdenacao}${
          tipoOrdenacao === TipoOrdenacao.Crescente ? '' : '_Desc'
        }`
      : undefined

    const filtros = queryString.stringify({
      cpf,
      nome,
      email,
      userId,
      usuarioPerfilFiltro,
      dataCriacaoProfessor,
      quantidadeRegistros,
      pagina,
      ordem,
      role,
      paginated
    })

    const {
      data: { itens, quantidade }
    } = await gatewayApi.get<PesquisaCursosCertificacaoResposta>(
      `${urlBase}/professores?${filtros}`
    )

    const opcoesPaginacao = {
      pagina,
      tamanhoPagina: quantidadeRegistros,
      totalRegistros: quantidade,
      totalPaginas: Math.ceil(quantidade / quantidadeRegistros)
    }

    return new Promise(resolve =>
      resolve({ registros: itens, opcoesPaginacao })
    )
  } catch {
    return null
  }
}

export const InserirProfessorCertificacao = async (
  payload: ProfessorCertificacaoPayload,
  usuarioId: string
): Promise<any> => {
  const response = await gatewayApi.post<{ cursoId: string }>(
    `${urlBase}/professores/criar`,
    {
      cpf: payload.cpf,
      nome: payload.nome,
      email: payload.email,
      escolaridade: payload.escolaridade,
      profissao: payload.profissao,
      aptidoes: payload.aptidoes,
      lattes: payload.lattes,
      usuarioPerfilId: usuarioId
    }
  )
  return response.data
}

export const EditarProfessorCertificacao = async (
  id: string,
  payload: ProfessorCertificacaoPayload,
  usuarioId: string
): Promise<boolean> => {
  await gatewayApi.put<RespostaPadraoAPI>(
    `${urlBase}/${id}/professores/editar`,
    {
      cpf: payload.cpf,
      nome: payload.nome,
      email: payload.email,
      escolaridade: payload.escolaridade,
      profissao: payload.profissao,
      aptidoes: payload.aptidoes,
      lattes: payload.lattes,
      usuarioPerfilId: usuarioId
    }
  )

  return true
}

export const RequisitarProfessorCertificacao = async (
  id: string
): Promise<ProfessorCertificacaoPayload> => {
  const { data } = await gatewayApi.get<ProfessorCertificacaoPayload>(
    `${urlBase}/${id}/professores`
  )

  return data
}

export const EnviarDocumentosProfessorCertificacao = async (
  professorId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/documentos/professor/${professorId}`
  const resposta = await gatewayApi.post(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const RequisitarDocumentoProfessorCertificacao = async (
  professorId: string,
  documentoId: string
): Promise<Documento> => {
  const resposta = await gatewayApi.get(
    `${urlBase}/professores/resumo-documentos/${professorId}/documento/${documentoId}/visualizar`
  )

  if (resposta?.status !== 200) return null

  return resposta.data
}

export const ObterResumoDeDocumentosProfessorCertificacao = async (
  professorId: string
): Promise<ResumoDocumentosProfessorCertificacao[]> => {
  const { data } = await gatewayApi.get<
    RespostaPaginacao<ResumoDocumentosProfessorCertificacao>
  >(`${urlBase}/professores/resumo-documentos/${professorId}`)

  if (!data) {
    return [] as ResumoDocumentosProfessorCertificacao[]
  }

  return data.itens
}

export const DownloadDocumentosProfessorCertificacao = async (
  professorId: string,
  documentoId: string
): Promise<void> => {
  const rota = `${urlBase}/professores/resumo-documentos/${professorId}/documento/${documentoId}`
  const config = { responseType: 'blob' } as AxiosRequestConfig
  const resposta = await gatewayApi.get(rota, config)

  if (resposta?.status !== 200) return null

  if (resposta.data) {
    saveAs(resposta.data)
  }
}

export const EditarDocumentosProfessorCertificacao = async (
  professorId: string,
  form: FormData
): Promise<boolean> => {
  const rota = `${urlBase}/professores/documento/${professorId}/editar`
  const resposta = await gatewayApi.put(rota, form, headers)

  return Boolean(resposta.status < 300)
}

export const RequisitarTodosProfessoresCertificacao = async (
  userId: string,
  role: Visao
): Promise<any> => {
  const filtros = queryString.stringify({
    userId,
    role
  })

  const { data } = await gatewayApi.get<ProfessorCertificacaoPayload>(
    `${urlBase}/professores/todos?${filtros}`
  )

  return data
}

export const RemoverDocumentoProfessorCertificacao = async (
  professorId: string,
  documentoId: string
): Promise<boolean> => {
  await gatewayApi.delete(
    `${urlBase}/professores/resumo-documentos/${professorId}/documento/${documentoId}/excluir`
  )

  return true
}

export const ValidarDocumentosParceiro = async (
  documentos: DocumentosParaAprovacao
): Promise<boolean> => {
  const { data } = await gatewayApi.put<ResultadoDaAprovacaoDeDocumentos>(
    `${urlBase}/documentos/parceiro/validar`,
    documentos
  )

  return Boolean(data.sucesso)
}

export const ValidarDocumentosTurma = async (
  documentos: DocumentosParaAprovacao
): Promise<boolean> => {
  const { data } = await gatewayApi.put<ResultadoDaAprovacaoDeDocumentos>(
    `${urlBase}/documentos/turma/validar`,
    documentos
  )

  return Boolean(data.sucesso)
}

export const ValidarDocumentosCurso = async (
  documentos: DocumentosParaAprovacao
): Promise<boolean> => {
  const { data } = await gatewayApi.put<ResultadoDaAprovacaoDeDocumentos>(
    `${urlBase}/documentos/curso/validar`,
    documentos
  )

  return Boolean(data.sucesso)
}

export const ValidarDocumentosProfessor = async (
  documentos: DocumentosParaAprovacao
): Promise<boolean> => {
  const { data } = await gatewayApi.put<ResultadoDaAprovacaoDeDocumentos>(
    `${urlBase}/documentos/professor/validar`,
    documentos
  )

  return Boolean(data.sucesso)
}

export const ValidarDocumentosAluno = async (
  documentos: DocumentosParaAprovacao
): Promise<boolean> => {
  const { data } = await gatewayApi.put<ResultadoDaAprovacaoDeDocumentos>(
    `${urlBase}/documentos/aluno/validar`,
    documentos
  )

  return Boolean(data.sucesso)
}

export const ObterDocumentosCertificacaoFilaTrabalho = async (
  filtros: {
    nomeUsuario?: string
    turma?: string
    categoria?: string
    status?: string
    dataAberturaInicio?: string
    dataAberturaFim?: string
    dataFechamentoInicio?: string
    dataFechamentoFim?: string
    pagina?: number
    tamanhoPagina?: number
  }
): Promise<any[]> => {
  const params = new URLSearchParams()
  
  if (filtros.nomeUsuario) params.append('nomeUsuario', filtros.nomeUsuario)
  if (filtros.turma) params.append('turma', filtros.turma)
  if (filtros.categoria) params.append('categoria', filtros.categoria)
  if (filtros.status) params.append('status', filtros.status)
  if (filtros.dataAberturaInicio) params.append('dataAberturaInicio', filtros.dataAberturaInicio)
  if (filtros.dataAberturaFim) params.append('dataAberturaFim', filtros.dataAberturaFim)
  if (filtros.dataFechamentoInicio) params.append('dataFechamentoInicio', filtros.dataFechamentoInicio)
  if (filtros.dataFechamentoFim) params.append('dataFechamentoFim', filtros.dataFechamentoFim)
  if (filtros.pagina) params.append('pagina', filtros.pagina.toString())
  if (filtros.tamanhoPagina) params.append('tamanhoPagina', filtros.tamanhoPagina.toString())

  const { data } = await gatewayApi.get(`${urlBase}/documentos/fila-trabalho?${params.toString()}`)

  return data
}

export const ObterTicketsParceiroCertificacaoFilaTrabalho = async (
  filtros: FiltrosTicketParceiroCertificacao
): Promise<PesquisaTicketParceiroCertificacaoDados> => {
  const params = new URLSearchParams()

  if (filtros.nomeAluno) params.append('nomeAluno', filtros.nomeAluno)
  if (filtros.nomeTurma) params.append('nomeTurma', filtros.nomeTurma)
  if (filtros.categoria) params.append('categoria', filtros.categoria)
  if (filtros.status) params.append('status', filtros.status)
  if (filtros.tipo) params.append('tipo', filtros.tipo)
  if (filtros.dataCriacaoInicio) params.append('dataCriacaoInicio', filtros.dataCriacaoInicio)
  if (filtros.dataCriacaoFim) params.append('dataCriacaoFim', filtros.dataCriacaoFim)
  if (filtros.pagina) params.append('pagina', filtros.pagina.toString())
  if (filtros.tamanhoPagina) params.append('tamanhoPagina', filtros.tamanhoPagina.toString())
  if (filtros.userId) params.append('userId', filtros.userId)
  if (filtros.role !== undefined) params.append('role', filtros.role.toString())

  const { data } = await gatewayApi.get<PesquisaTicketParceiroCertificacaoDados>(
    `${urlBase}/tickets/fila-trabalho?${params.toString()}`
  )

  return data
}

export const ObterTicketParceiroCertificacaoPorId = async (
  idTicket: string
): Promise<TicketParceiroCertificacaoHistorico> => {
  const { data } = await gatewayApi.get<TicketParceiroCertificacaoHistorico>(
    `${urlBase}/tickets/fila-trabalho/${idTicket}`
  )

  return data
}

export const FinalizarTicketParceiroCertificacao = async (
  idTicket: string,
  observacao?: string
): Promise<void> => {
  await gatewayApi.put(`${urlBase}/tickets/fila-trabalho/${idTicket}/finalizar`, {
    observacao
  })
}
